import {Splide} from "@splidejs/splide";

const academyDetailSlider = {
    init() {
        const arrowPath = 'M26.0298 19.4703C26.3204 19.7609 26.3204 20.239 26.0298 20.5297L17.0298 29.5297C16.7392 29.8203 16.261 29.8203 15.9704 29.5297C15.6798 29.239 15.6798 28.7609 15.9704 28.4703L24.4407 20L15.9704 11.5297C15.6798 11.239 15.6798 10.7609 15.9704 10.4703C16.261 10.1797 16.7392 10.1797 17.0298 10.4703L26.0298 19.4703Z';
        if (document.getElementById('academy-detail-slider')) {
            let academySlider = new Splide('#academy-detail-slider', {
                type: 'loop',
                rewind: true,
                pagination: true,
                arrows: false,
                arrowPath: arrowPath,
                perPage: 1,
                breakpoints: {
                    1024: {
                        perPage: 1,
                        type: 'loop',
                        padding: {right: '10%'},
                        gap: '1rem',
                    }
                }
            });

            // This should destroy the carousel if there are less than x items (depends on viewport and perPage setting)
            // https://splidejs.com/guides/overflow/#loop-carousel
            academySlider.on("overflow", function (isOverflow) {
                // Reset the carousel position
                academySlider.go(0);

                if (!isOverflow) {
                    // Destroy the carousel in case of not removable padding-right from breakpoint
                    academySlider.destroy(true);
                }
            });

            academySlider.mount();
        }
    }
};

export {academyDetailSlider as default};
